import { InjectionToken } from '@angular/core';

export const ENABLE_TWITCH_STREAM_SELECTOR = new InjectionToken<boolean>(
  'ENABLE_TWITCH_STREAM_SELECTOR',
);
